// extracted by mini-css-extract-plugin
export default {"container":"Trait_container__rtVPB","traitTaken":"Trait_traitTaken__tXZOU","stats":"Trait_stats__oWixq","loading":"Trait_loading__BCbAS"};